// https://www.dbos.dev/webcast-dbos-conductor-intro

import { SiteLayout } from '@components/layout/SiteLayout';
import { FooterCtaBuildYourReliableBackend } from '@components/layout/FooterCtas';
import { ScriptEmbed } from '@components/webflow';

export function WebcastDbosConductorIntroPage() {
  return (
    <SiteLayout banner={true} footerCta={<FooterCtaBuildYourReliableBackend />}>
      <style
        dangerouslySetInnerHTML={{
          __html:
            "form#hsForm_f78959e7-8218-449d-8ba2-aa4500a40cf8 label {\ncolor: var(--color-palette--color-neutral-500) !important;\nfont-family: var(--sizing--text-font-body), 'Helvetica Neue', sans-serif !important;\nfont-size: var(--sizing--sizing-400) !important;\n\n}",
        }}
      />
      <section className="hero-col-2">
        <div className="w-layout-hflex hero-col-left">
          <div className="hero-heading">
            <h1 className="text-heading-h1">
              {'Webcast:\u00a0'}
              <br />
              Durable Execution on Any Platform
            </h1>
            <div className="text-heading-h1 text-heading-blur">
              {'The '}
              <span className="text-gradient">easiest</span>
              {' way to build cloud-native backends'}
            </div>
          </div>
          <div className="text-body">
            <strong>{'Thursday April 17 | 2PM\u00a0EDT | 11AM\u00a0PDT'}</strong>
            <br />
            <br />
            <em className="italic-text">
              The open source DBOS Transact durable execution library is the easiest way to make your cloud applications
              resilient to failure and fully observable.
              <br />
              <br />
              In this webinar, DBOS co-founders, Qian Li and Peter Kraft will show you how to deploy, scale, and manage
              DBOS Transact applications on any platform.
              <br />
              <br />
              Agenda:
              <br />
              {'- Making code durable & observable with DBOS Transact'}
              <br />- Deployment targets for DBOS Transact applications:
              <br />
              {'\u00a0\u00a0\u00a0- Self-hosted on AWS, Azure, GCP, on-premises'}
              <br />
              {'\u00a0\u00a0\u00a0- Severless hosting on fully-managed DBOS Cloud'}
              <br />- Walkthrough of the new DBOS Conductor functionality
              <br />
              {'\u00a0\u00a0\u00a0- Scaling self-hosted DBOS Transact apps'}
              <br />
              {'\u00a0\u00a0\u00a0- Monitoring, troubleshooting durable workflows &\u00a0queues'}
              <br />
              {'- Q and A\u200d'}
            </em>
            <br />
          </div>
        </div>
        <div className="w-layout-hflex hero-col-right">
          <h2 className="text-heading-h2">Join the Webcast</h2>
          <div className="text-body">
            Sign up below to save your spot in the April 17 live webcast. If you cannot join us live, all registrants
            will receive a link to a recording of the session.
          </div>
          <ScriptEmbed
            className="embedded-form w-embed w-script"
            html={
              '<script charset="utf-8" type="text/javascript" src="//js.hsforms.net/forms/embed/v2.js"></script>\n<script>\n  hbspt.forms.create({\n    portalId: "45237820",\n    formId: "4190e8cd-2916-4c95-a479-1fde04703d95",\n    region: "na1"\n  });\n</script>'
            }
          />
        </div>
      </section>
    </SiteLayout>
  );
}
